import {Component, EventEmitter, Inject, Input, NgZone, OnInit, Optional, Output, TemplateRef, ViewChild} from '@angular/core';
import {ToastrService} from "ngx-toastr";
import {EnterpriseService} from "../../enterprise/services/enterprise-service";
import {IAppSettingsWrap, IPlayerProps, IStationData} from "../../../interfaces";
import {SelectionModel} from "@angular/cdk/collections";
import {LazyImage} from "../../../components/lazy-image/lazy-image";
import {TranslocoService} from "@ngneat/transloco";
import {delay, filter, map, switchMap} from 'rxjs/operators';
import {Compbaser} from "../../../components/compbaser";
import {LocalStoreService, StoreSelectorsService} from "../../../services";
import {retryWithBackoff} from "../../../../libs/rxjs/retryWithBackoff";
import { HttpClient } from "@angular/common/http";
import * as _ from "lodash";
import {compareIds, isNullOrUndefOrEmpty} from "../../../common";
import {Lib} from "../../../../libs/Lib";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";

declare var jQuery: any;

@Component({
    selector: 'app-station-snapshot',
    templateUrl: './station-snapshot.component.html',
    styleUrls: ['./station-snapshot.component.scss']
})
export class StationSnapshotComponent extends Compbaser implements OnInit {

    m_loading = false;
    showEnlarge = false;
    scenesSimple: { name, sceneId }  [];
    scenes: IPlayerProps[] = [];
    coreAppData: IAppSettingsWrap;
    selectedSceneId = '';
    selectionModel: SelectionModel<number>;
    snapshotUrl = '';
    once = false;
    screenshotFullUrl = '';
    dialogRefLargeSnap;
    snapScale = 0.1;

    @Input() enabled = true;
    @Output() snapCompleted: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild("dialogScreenShot", {read: TemplateRef}) dialogScreenShot: TemplateRef<any>;
    @ViewChild(LazyImage) lazyImage: LazyImage;
    @ViewChild("archiveModal", {read: TemplateRef}) archiveModal: TemplateRef<any>;

    constructor(@Optional() @Inject(MAT_DIALOG_DATA) data, public override dialog: MatDialog,
                private storeSelector: StoreSelectorsService,
                private toastr: ToastrService,
                private localStoreService: LocalStoreService,
                private enterpriseService: EnterpriseService,
                private _http: HttpClient,
                private zone: NgZone,
                private translocoService: TranslocoService) {
        super();

        this.snapScale = this.localStoreService.getStorageValConfig('snapScale') as number;
        if (isNullOrUndefOrEmpty(this.snapScale) || isNaN(this.snapScale)) {
            this.snapScale = 0.1;
        }

        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
        this.cod(
            this.storeSelector.appStore.select(appStore => appStore.users.scenes)
                .pipe(filter(data => data != null))
                .subscribe((i_scenes: IPlayerProps[]) => {
                    this.scenes = _.orderBy(i_scenes, (v: IPlayerProps) => {
                        return v.Player.$.label.toLocaleLowerCase();
                    }, ['asc']);
                    this.scenesSimple = [];
                    this.scenes.forEach((scene) => {
                        this.scenesSimple.push({name: scene.Player.$.label, sceneId: scene.Player.$.id});
                    });
                })
        );
    }

    ngOnInit() {
    }

    onSnapCompleted(event) {
        if (event.status === 'maximize') {
            const urlPart = event.snapshot.split('business');
            this.screenshotFullUrl = `${this.coreAppData[1].cloudSnapshots}/business${urlPart[1]}`;
            this.dialogRefLargeSnap = this.dialog.open(this.dialogScreenShot, {
                height: '80%',
                width: '80%',
            });
            // this.cod(
            //     dialogRefLargeSnap.dialogRefVal.afterClosed()
            //         .pipe(take(1))
            //         .subscribe((result: IDialogGetAsset) => {
            //             if (!result) return;
            //             this.assignSceneName(result.selected);
            //         })
            // );
        }
    }

    onCloseLargeSnapView() {
        this.dialogRefLargeSnap.close();
    }

    onMaximize() {
        if (!this.showEnlarge) return;
        this.snapCompleted.emit({status: 'maximize', snapshot: this.snapshotUrl});
        this.onSnapCompleted({status: 'maximize', snapshot: this.snapshotUrl});
    }

    _onLoaded() {
        this.snapCompleted.emit({status: 'loaded', snapshot: this.snapshotUrl});
        this.showEnlarge = true;
    }

    _onError() {
        this.snapCompleted.emit({status: 'error', snapshot: this.snapshotUrl});
        this.showEnlarge = false;
    }

    _onCompleted() {
        this.snapCompleted.emit({status: 'completed', snapshot: this.snapshotUrl});
    }

    private sendSnapshotUser(i_fileName, i_quality, selectedStation: IStationData, version, i_callBack) {
        const fileExtension = '.jpg';
        // if (version && compareIds(2, version))
        //     fileExtension = '.png';
        const stationId = selectedStation.stat.$.id;
        this.showToast('snapshot');
        const fileName = i_fileName;
        Lib.DevShow('snap ' + fileName);
        let customerUserName;
        if (this.coreAppData[0].dashboard) {
            this.storeSelector.getEnterpriseBusinessUsers().pipe(
                map((b) => {
                    return b.BusinessUsers
                        .find((v) => {
                            return v.$.businessId === selectedStation.stat.$.businessId;
                        });
                }),
                switchMap((enterpriseBusinessUser) => {
                    customerUserName = enterpriseBusinessUser.$.name;
                    return this.enterpriseService.getCredentials(enterpriseBusinessUser.$.name);
                }))
                .subscribe((pass) => {
                    if (selectedStation.stat?.$?.version == '2') {
                        this.snapshotUrl = `${this.coreAppData[1].protocol}${selectedStation.stat.$.source}/Snapshots/business${selectedStation.stat.$.businessId}/station${stationId}/${i_fileName}${fileExtension}`;
                        this.initCapture(
                            `${this.coreAppData[1].protocol}${selectedStation.stat.$.source}/WebService/sendCommand.ashx?i_user=${customerUserName}&i_password=${Lib.Base64().encode(pass)}&i_stationId=${stationId}&i_command=captureScreen2&i_param1=${i_fileName}&i_param2=${i_quality}&base64=1`,
                            i_callBack
                        );
                        setTimeout(() => {
                            this.sendSnapshotUserDashboard(selectedStation.stat.$.source, customerUserName, pass, stationId, fileName, i_quality);
                        }, 2000);
                    } else {
                        this.snapshotUrl = `${this.coreAppData[1].protocol}${selectedStation.stat.$.source}/Snapshots/business${selectedStation.stat.$.businessId}/station${stationId}/${fileName}${fileExtension}`;
                        this.initCapture(
                            `${this.coreAppData[1].protocol}${selectedStation.stat.$.source}/WebService/sendCommand.ashx?i_user=${customerUserName}&i_password=${Lib.Base64().encode(pass)}&i_stationId=${selectedStation.stat.$.id}&i_command=captureScreen2&i_param1=${fileName}&i_param2=${i_quality}&base64=1`,
                            i_callBack
                        );
                    }
                });
        } else {
            this.snapshotUrl = `${this.coreAppData[1].protocol}${this.coreAppData[0].businessDomain}/Snapshots/business${this.coreAppData[0].businessId}/station${stationId}/${i_fileName}${fileExtension}`;
            console.log(`>>>> looking version ${version} for snap at: ${this.snapshotUrl}`);
            if (version && compareIds(2, version)) {
                this.initCapture(
                    `${this.coreAppData[1].protocol}${this.coreAppData[0].businessDomain}/WebService/sendCommand.ashx?i_user=${this.coreAppData[0].email}&i_password=${Lib.Base64().encode(this.coreAppData[0].passwordNew)}&i_stationId=${stationId}&i_command=captureScreen2&i_param1=${i_fileName}&i_param2=${i_quality}&base64=1`,
                    i_callBack
                );
                setTimeout(() => {
                    this.sendSnapshotUserV2(stationId, fileName, i_quality);
                }, 2000);
            } else {
                this.initCapture(
                    `${this.coreAppData[1].protocol}${this.coreAppData[0].businessDomain}/WebService/sendCommand.ashx?i_user=${this.coreAppData[0].email}&i_password=${Lib.Base64().encode(this.coreAppData[0].passwordNew)}&i_stationId=${stationId}&i_command=captureScreen2&i_param1=${i_fileName}&i_param2=${i_quality}&base64=1`,
                    i_callBack
                );
            }
        }
    }

    private sendSnapshotUserDashboard(source, user, pass, stationId, i_fileName, i_quality) {
        const segment = 'Web';
        const url = `${this.coreAppData[1].protocol}${source}/${segment}/sendCommand.ashx?user=${user}&pass=${Lib.Base64().encode(pass)}&stationId=${stationId}&base64=1`;
        Lib.DevShow('sendSnapshotUserDashboard ' + url);
        this.cod(
            this._http.post(url, {
                command: 'captureScreen',
                fileName: i_fileName,
                scale: i_quality,
            }).pipe(
                retryWithBackoff(url, this.storeSelector, this.toastr),
                delay(_.random(1, 1000)),
                map((v) => {
                    return v;
                })
            ).subscribe((e) => {
            })
        );
    }

    private sendSnapshotUserV2(stationId, i_fileName, i_quality) {
        const segment = 'Web';
        const url = `${this.coreAppData[1].protocol}${this.coreAppData[0].businessDomain}/${segment}/sendCommand.ashx?user=${this.coreAppData[0].email}&pass=${Lib.Base64().encode(this.coreAppData[0].passwordNew)}&stationId=${stationId}&base64=1`;
        Lib.DevShow('sendSnapshotUserV2 ' + url);
        this.cod(
            this._http.post(url, {
                command: 'captureScreen',
                fileName: i_fileName,
                scale: i_quality,
            }).pipe(
                retryWithBackoff(url, this.storeSelector, this.toastr),
                delay(_.random(1, 1000)),
                map((v) => {
                    return v;
                })
            ).subscribe((e) => {
            })
        );
    }

    private initCapture(url: string, callback: (r: {}) => void) {
        /** Old jQuery version
         console.log('snap: ' + this.snapshotUrl);
         url = `${this.coreAppData[1].protocol}${this.coreAppData[0].businessDomain}/WebService/sendCommand.ashx?i_user=${this.coreAppData[0].email}&i_password=${this.coreAppData[0].passwordNew}&i_stationId=${stationId}&i_command=captureScreen2&i_param1=${i_fileName}&i_param2=${i_quality}&callback=?`;
         this.zone.runOutsideAngular(() => {
         console.log('snap: ' + url);
         jQuery.getJSON(url, i_callBack);
         });
         **/
        Lib.DevShow('initCapture ' + url);
        this.cod(
            this._http.jsonp<any>(url, 'callback').pipe(
                retryWithBackoff(url, this.storeSelector, this.toastr),
                delay(_.random(1, 1000)),
                map((v) => v)
            ).subscribe((r) => {
                callback(r);
            })
        );
    }

    public takeSnapshotUser(selectedStation: IStationData, businessId, version) {
        const d = new Date().getTime();
        this.snapshotUrl = '';
        this.m_loading = true;
        let scale = this.localStoreService.getStorageValConfig('snapScale');
        if (isNullOrUndefOrEmpty(scale)) scale = '0.2';
        this.sendSnapshotUser(d, scale, selectedStation, version, (v) => {
            const a = this.snapshotUrl.split('/');
            const b = a[a.length - 1];
            const c = `${this.coreAppData[1].cloudSnapshots}/business${businessId}/station${selectedStation.stat.$.id}/${b}`;
            // console.log('snap: ' + c);
            // const r = `https://earth.signage.me/Snapshots/business391067/station${selectedStation.stat.$.id}/${b}`;
            // this.lazyImage.urls = [r];
            this.lazyImage.urls = [c];

        });
    }

    public resetSnapshotSelection() {
        if (this.lazyImage)
            this.lazyImage.resetToDefault();
    }

    private showToast(i_command) {
        this.toastr.info(this.translocoService.translate('toast.remoteComSent', {}, this.translocoService.getActiveLang()) + ' ' + i_command, this.translocoService.translate('toast.remoteCap', {}, this.translocoService.getActiveLang()));
    }
}
